import { DetailedHTMLProps, HTMLAttributes } from 'react';
import {
  ImageIconWrapperStyled,
  ImageWrapperStyled,
  RootStyled,
} from './logo-image-upload-viewer.styled';
import { IconSize } from '@constants';
import { useTheme } from '@mui/material';
import { PhotoIcon } from '@heroicons/react/24/outline';

export interface LogoImageUploadViewerProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  imageUrl: string | undefined;
  isSelected: boolean;
}

const LogoImageUploadViewer = ({
  isSelected,
  imageUrl,
  ...props
}: LogoImageUploadViewerProps) => {
  const theme = useTheme();
  return (
    <RootStyled {...props}>
      <ImageWrapperStyled>
        <img src={imageUrl} alt="Uploaded" />
      </ImageWrapperStyled>
      <ImageIconWrapperStyled>
        <PhotoIcon
          height={IconSize.buttonIcon}
          color={theme.palette.white.main}
        />
      </ImageIconWrapperStyled>
    </RootStyled>
  );
};

export default LogoImageUploadViewer;
